export default "__VITE_ASSET__DewLwnzX__"